import { http } from '../client';
import type { CallOptions, WriteOptions } from '../types';
import type { SubscriptionsApi } from './subscriptions';

// Paths mirror subsystems/commerce/facade/adapters/admin-api/src/admin/subscriptions.rs.
const seg = encodeURIComponent;
const rd = (o?: CallOptions) => ({ signal: o?.signal });
const wr = (o?: WriteOptions) => ({ signal: o?.signal, idempotencyKey: o?.idempotencyKey, notifyCustomer: o?.notifyCustomer });

export const subscriptionsHttp: SubscriptionsApi = {
  listSubscriptions: (f, opts) =>
    http.get('api', '/services', {
      query: { state: f.state ?? undefined, q: f.q?.trim() || undefined, group: f.group ?? undefined, customer_id: f.customer_id ?? undefined, limit: f.limit, offset: f.offset },
      ...rd(opts),
    }),
  getSubscription: (id, opts) => http.get('api', `/services/${seg(id)}`, rd(opts)),
  listWaitingServices: (q, opts) => http.get('api', '/services/waiting', { query: { limit: q.limit }, ...rd(opts) }),
  listDueServices: (q, opts) => http.get('api', '/services/due', { query: { days: q.days, limit: q.limit }, ...rd(opts) }),
  listOverdueServices: (q, opts) => http.get('api', '/services/overdue', { query: { limit: q.limit }, ...rd(opts) }),
  completeDelivery: (id, body, opts) => http.post('api', `/services/${seg(id)}/complete-delivery`, body, wr(opts)),
  cancelDelivery: (id, body, opts) => http.post('api', `/services/${seg(id)}/cannot-deliver`, body, wr(opts)),
  extendSubscription: (id, body, opts) => http.post('api', `/services/${seg(id)}/extend`, body, wr(opts)),
  suspendSubscription: (id, body, opts) => http.post('api', `/services/${seg(id)}/suspend`, body, wr(opts)),
  unsuspendSubscription: (id, body, opts) => http.post('api', `/services/${seg(id)}/unsuspend`, body, wr(opts)),
  terminateSubscription: (id, body, opts) => http.post('api', `/services/${seg(id)}/terminate`, body, wr(opts)),
  orderService: (body, opts) => http.post('api', '/services/orders', body, wr(opts)),
};
